import removeEquipmentStore from "../store/removeEquipment";

// Custom hook để sử dụng và cập nhật cấu hình player
const useRemoveEquipment = (playerId) => {
    const rmEquipments = removeEquipmentStore((state) => state.rmEquipment);
    const setRmEquipment = removeEquipmentStore((state) => state.setRmEquipment);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        rmEquipment: playerId == null ? {} : rmEquipments[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        rmEquipments,
        setRmEquipment,
    };
};

export default useRemoveEquipment;
